import {requestHelper} from '../helpers/index';
import axiosInstance from '../../axios.instance';
import { maestroenv } from '../../helpers/maestroenv';
//import {pdfjs} from "react-pdf";

export const eSignService = {
  getESignDocumentById,
  getESignDocuments,
  uploadESignDocuments
};

async function getESignDocumentById(documentFields) {
  const docFlds = JSON.stringify(documentFields);
  return axiosInstance.post(`${maestroenv.REACT_APP_API_URL}/eSign/${documentFields.id}`,
    JSON.stringify(documentFields),
    {
      headers: {
        'content-type': 'application/pdf'
      },
      responseType: 'blob'
    })
    .then(response => {
      return response.data;
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

function getESignDocuments(eSignSearch) {
  return axiosInstance.post(`${maestroenv.REACT_APP_API_URL}/eSign`, JSON.stringify(eSignSearch))
    .then(response => {
      return response.data.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

function uploadESignDocuments(eSignData) {
  return axiosInstance.post(`${maestroenv.REACT_APP_API_URL}/eSign/uploadfiles`, eSignData)
    .then(response => {
      return response.data
    })
    .catch(function (error) {
      return Promise.reject(requestHelper.handleErrorResponse(error));
    });
}

